import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";

// Protejează rutele: autentificare + (opțional) permisiune pe modul.
// Meniurile nepermise sunt ascunse, dar și ruta directă este blocată.
export default function ProtectedRoute({ children, perm, perms }) {
  const { user, loading, hasPerm, hasAnyPerm } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "60vh" }}>
        <div className="spinner-border text-primary-600" role="status">
          <span className="visually-hidden">Se încarcă…</span>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }

  // Parolă implicită / forțată → redirecționează la schimbarea parolei înainte de orice altă pagină.
  if (user.trebuieSchimbaParola) {
    return <Navigate to="/schimba-parola" replace />;
  }

  if (perm && !hasPerm(perm)) {
    return (
      <div className="card">
        <div className="card-body text-center py-64">
          <h4 className="text-danger-main mb-8">Acces interzis</h4>
          <p className="text-secondary-light">Nu ai drepturi pentru acest modul.</p>
        </div>
      </div>
    );
  }
  if (perms && !hasAnyPerm(perms)) {
    return (
      <div className="card">
        <div className="card-body text-center py-64">
          <h4 className="text-danger-main mb-8">Acces interzis</h4>
          <p className="text-secondary-light">Nu ai drepturi pentru acest modul.</p>
        </div>
      </div>
    );
  }

  return children;
}
